import { render, staticRenderFns } from "./LangValue.vue?vue&type=template&id=fc54febc&scoped=true"
import script from "./LangValue.vue?vue&type=script&lang=js"
export * from "./LangValue.vue?vue&type=script&lang=js"
import style0 from "./LangValue.vue?vue&type=style&index=0&id=fc54febc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc54febc",
  null
  
)

export default component.exports